export const isValidUUID = (uuid: any): string | null => {
  if (!uuid || typeof uuid !== 'string') {
    return null;
  }

  const trimmedUuid = uuid.trim();

  if (!isNaN(Number(trimmedUuid))) {
    return null;
  }

  if (trimmedUuid.length !== 36) {
    return null;
  }

  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  return uuidRegex.test(trimmedUuid) ? trimmedUuid : null;
};
